// CMS client helper for Overgaard Pattegrise

export async function fetchCollection(collectionName) {
  try {
    const res = await fetch(`/_api/public/content/${collectionName}`)
    if (!res.ok) {
      console.warn(`CMS fetch failed for ${collectionName}: ${res.status}`)
      return []
    }
    const data = await res.json()
    if (Array.isArray(data)) return data
    if (data && Array.isArray(data.items)) return data.items
    return []
  } catch (err) {
    console.error(`Error fetching CMS collection ${collectionName}:`, err)
    return []
  }
}

export async function fetchPageBySlug(slug) {
  try {
    const items = await fetchCollection('pages')
    const page = items.find(
      (item) => item.slug === slug || (item.slug && item.slug._ === slug)
    )
    return page || null
  } catch (err) {
    console.error(`Error fetching page ${slug}:`, err)
    return null
  }
}

export async function fetchGalleryBySlug(slug) {
  try {
    const items = await fetchCollection('galleries')
    const gallery = items.find(
      (item) => item.slug === slug || (item.slug && item.slug._ === slug)
    )
    return gallery || null
  } catch (err) {
    console.error(`Error fetching gallery ${slug}:`, err)
    return null
  }
}
